import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { Member } from '@/features/iam/members/Member'

export type JobNoteProps = ModelProps<JobNote>

/**
 * A note on a job.
 */
export class JobNote extends Model<JobNote> {
  id = Id.none
  jobId = Id.none
  workspaceId = Id.none
  @observable accessor body = ''
  @observable accessor author = Member.none
  @observable accessor recipientUserPublicIds: Id[] = []
  @observable accessor dateCreated = unixEpoch()
}
